// extracted by mini-css-extract-plugin
export default {"modal":"OverwriteProject_modal__5Ew9s","modalDialog":"OverwriteProject_modalDialog__lxQ2A","button":"OverwriteProject_button__DMKuz","h4":"OverwriteProject_h4__7T9-m"};